import React from 'react';
import type { AnswerOptionProps } from '../../types';
import { cn } from '../../lib/utils';

const AnswerOption: React.FC<AnswerOptionProps> = ({
  option,
  index,
  selected,
  disabled,
  onClick,
}) => {
  const getColorClass = (idx: number) => {
    switch(idx) {
      case 0: return 'bg-response-a';
      case 1: return 'bg-response-b';
      case 2: return 'bg-response-c';
      case 3: return 'bg-response-d';
      default: return 'bg-response-a';
    }
  };

  const icons = [
    <svg key="leaf" className="w-12 h-12 opacity-50" viewBox="0 0 24 24" fill="currentColor">
      <path d="M17,8C8,10 5.9,16.17 3.82,21.34L5.71,22L6.66,19.7C7.14,19.87 7.64,20 8,20C19,20 22,3 22,3C21,5 14,5.25 9,6.25C4,7.25 2,11.5 2,13.5C2,15.5 3.75,17.25 3.75,17.25C7,8 17,8 17,8Z"/>
    </svg>,
    <svg key="pumpkin" className="w-12 h-12 opacity-50" viewBox="0 0 24 24" fill="currentColor">
      <path d="M11.5,0.5C11,0.5 10.5,1 10.5,1.5C10.5,2 11,2.5 11.5,2.5C12,2.5 12.5,2 12.5,1.5C12.5,1 12,0.5 11.5,0.5M12,3C9.5,3 7.5,4.5 6.5,6.5C5.5,5.5 4,5 2.5,5C2,5 1.5,5.5 1.5,6C1.5,6.5 2,7 2.5,7C4,7 5,8 5,9.5C5,16 8,20 12,20C16,20 19,16 19,9.5C19,8 20,7 21.5,7C22,7 22.5,6.5 22.5,6C22.5,5.5 22,5 21.5,5C20,5 18.5,5.5 17.5,6.5C16.5,4.5 14.5,3 12,3Z"/>
    </svg>,
    <svg key="acorn" className="w-12 h-12 opacity-50" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12,2C12,2 9,4.5 9,7.5C9,9.43 10.57,11 12.5,11C14.43,11 16,9.43 16,7.5C16,4.5 13,2 13,2L12,2M12.5,13C11,13 9.63,12.5 8.5,11.69C7.5,14.5 6,17 4,19L8,22L12,19L16,22L20,19C18,17 16.5,14.5 15.5,11.69C14.37,12.5 13,13 12.5,13Z"/>
    </svg>,
    <svg key="berries" className="w-12 h-12 opacity-50" viewBox="0 0 24 24" fill="currentColor">
      <path d="M6,10C4.9,10 4,10.9 4,12C4,13.11 4.9,14 6,14C7.11,14 8,13.11 8,12C8,10.9 7.11,10 6,10M11,7C9.9,7 9,7.9 9,9C9,10.11 9.9,11 11,11C12.11,11 13,10.11 13,9C13,7.9 12.11,7 11,7M15,10C13.9,10 13,10.9 13,12C13,13.11 13.9,14 15,14C16.11,14 17,13.11 17,12C17,10.9 16.11,10 15,10M16.5,4.5L14.5,1.5L12,3L11,1L6,6L8,8L9,7L11,9L15,13L15.5,12.5C16.28,11.72 17,10.5 17,9C17,7.62 16.35,6.47 15.5,5.5L16.5,4.5Z"/>
    </svg>
  ];
  
  const letters = ['A', 'B', 'C', 'D'];
  
  return (
    <button
      className={cn(
        'w-full rounded-2xl p-6 text-white font-semibold transition-all duration-300 hover:scale-105',
        getColorClass(index),
        'flex items-center justify-between',
        'shadow-[0_4px_12px_rgba(0,0,0,0.15)]',
        selected && 'ring-4 ring-white ring-opacity-60 scale-105',
        disabled && 'opacity-70 hover:scale-100'
      )}
      onClick={onClick}
      disabled={disabled}
      aria-pressed={selected}
    >
      <div className="flex items-center gap-4">
        <div className="relative">
          {icons[index]}
        </div>
        <span className="text-lg">
          {option.text}
        </span>
      </div>
      <span className="text-sm opacity-80 font-normal">
        {letters[index]}
      </span>
    </button>
  );
};

export default AnswerOption;